import React from "react";
import { Link } from "react-router-dom";
import NotificationBar from "../components/home/NotifictionBar";

const NotFound = () => {
  return (
    <>
      <NotificationBar />
      <section className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-2xl mx-auto text-center px-4">
          {/* 404 Icon */}
          <div className="mb-8">
            <div className="relative">
              <div className="w-32 h-32 mx-auto bg-orange-500 rounded-full flex items-center justify-center">
                <span className="text-6xl font-bold text-white">404</span>
              </div>
              <div className="absolute -top-2 -right-2 w-8 h-8 bg-red-500 rounded-full flex items-center justify-center">
                <svg
                  className="w-5 h-5 text-white"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* Error Message */}
          <h1 className="text-4xl md:text-6xl font-bold text-gray-800 mb-4">
            Page Not Found
          </h1>
          <p className="text-xl text-gray-600 mb-8">
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>

          {/* Search Suggestion */}
          <div className="bg-white rounded-lg shadow-md p-6 mb-8">
            <h2 className="text-lg font-semibold text-gray-800 mb-3">
              Looking for something specific?
            </h2>
            <p className="text-gray-600 mb-4">
              Try searching for vehicles or browse our available inventory.
            </p>
            <Link
              to="/search"
              className="inline-block bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition-colors font-medium"
            >
              Browse Vehicles
            </Link>
          </div>

          {/* Navigation Options */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
            <Link
              to="/"
              className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow border-l-4 border-blue-500"
            >
              <div className="text-blue-500 mb-2">
                <svg
                  className="w-8 h-8 mx-auto"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
                </svg>
              </div>
              <h3 className="font-semibold text-gray-800">Home</h3>
              <p className="text-sm text-gray-600">Return to homepage</p>
            </Link>

            <Link
              to="/search"
              className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow border-l-4 border-green-500"
            >
              <div className="text-green-500 mb-2">
                <svg
                  className="w-8 h-8 mx-auto"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414L13.89 13.89A6 6 0 012 8z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <h3 className="font-semibold text-gray-800">Search</h3>
              <p className="text-sm text-gray-600">Find vehicles</p>
            </Link>

            <Link
              to="/contact"
              className="bg-white p-4 rounded-lg shadow-md hover:shadow-lg transition-shadow border-l-4 border-purple-500"
            >
              <div className="text-purple-500 mb-2">
                <svg
                  className="w-8 h-8 mx-auto"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </div>
              <h3 className="font-semibold text-gray-800">Contact</h3>
              <p className="text-sm text-gray-600">Get help</p>
            </Link>
          </div>

          {/* Back Button */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => window.history.back()}
              className="bg-gray-600 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition-colors font-medium"
            >
              ← Go Back
            </button>
            <Link
              to="/"
              className="bg-orange-500 text-white px-6 py-3 rounded-lg hover:bg-orange-600 transition-colors font-medium"
            >
              Go Home
            </Link>
          </div>

          {/* Additional Help */}
          <div className="mt-12 text-center">
            <p className="text-gray-500 text-sm">
              If you believe this is an error, please{" "}
              <Link to="/contact" className="text-orange-500 hover:underline">
                contact our support team
              </Link>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFound;
